"use client";
import { useLogout } from "@/hooks/useLogout";
import { useRouter } from "@/i18n/routing";
import { CenterPopup } from "antd-mobile";
import { useTranslations } from "next-intl";
import { FC, PropsWithChildren, useEffect, useRef, useState } from "react";
import "./style.scss";

/**
 * @description 底部组件
 */
export interface ItemComProps {
    type?: string;
    callbackFun?: (params: any) => void;
}

const ModalCom: FC<PropsWithChildren<ItemComProps>> = () => {
    const t = useTranslations("ProfilePage");
    const { logout } = useLogout();
    const [visible, setVisible] = useState(false);
    const element = useRef<HTMLElement | null>(null);
    const router = useRouter();
    const goPage = (path = "/") => {
        router.push(path);
    };

    useEffect(() => {
        element.current = document.getElementById("app");
    }, []);

    return (
        <>
            {/* {
                token ? <span className="logOut" onClick={onOpen}>{t('Sair')}</span> : (
                    <span className="logOut" onClick={() => goPage('/login')}>{t('Login')}</span>
                )
            } */}

            {
                <span className="logOut" onClick={() => setVisible(true)}>
                    <i className={"iconfont icon-tuichu mr-[5px] text-[24px]"}></i>
                    {t("Sair")}
                </span>
            }

            <CenterPopup
                visible={visible}
                getContainer={element.current}
                onMaskClick={() => {
                    setVisible(false);
                }}
            >
                <div className={"body1-box"}>
                    <p className="modal-p-box">{t("Deseja")}</p>
                    <div className="footer1-box">
                        <span className="modal-span-box" onClick={() => setVisible(false)}>
                            {t("Cancelar")}
                        </span>
                        <span className="modal-span-box active" onClick={logout}>
                            {t("Continuar")}
                        </span>
                    </div>
                </div>
            </CenterPopup>
        </>
    );
};

export default ModalCom;
